import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useMenuAPI() {
  const { menuSlug, liveEditMode, languageRef } = useStorage();

  function loadMenuFromRemote(menuId) {
    const url = `/vbeta2/menu/${menuId ?? menuSlug}`;

    return axios({
      url,
      params: {
        live: liveEditMode,
        lang: languageRef.current?.tag,
      },
      method: 'get',
      headers: {
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  async function getMenuImageFromRemote(url) {
    if (url == null) return null;

    return axios({
      url,
      method: 'get',
    });
  }

  return {
    loadMenuFromRemote,
    getMenuImageFromRemote,
  };
}

export { useMenuAPI };
